<template>
    <div>
        <div class="modal fade" id="newThemeModal" tabindex="-1" role="dialog" aria-labelledby="fontModalLabel"
             aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="fontModalLabel">New Theme</h5>
                        <button type="button" class="btn-close" @click="noHandler" aria-label="Close"></button>
                    </div>

                    <new-theme-wizard :new-theme="newTheme" parent-class="modal-body"></new-theme-wizard>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click="yesHandler">Ok</button>
                        <button type="button" class="btn btn-secondary " @click="noHandler">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import ColorPicker from "../components/ColorPicker.vue";
import FontStyleEditor from "./FontStyleEditor.vue";
import ColorUtil from "../utils/ColorUtil";
import NewThemeWizard from "./NewThemeWizard.vue";

export default {
    name: 'NewThemeModal',
    components: {NewThemeWizard, FontStyleEditor, ColorPicker},
    props: {
        yesEvent: Function
    },
    data() {
        return {
            model: webase.model,
            currentModal: null,
            modalElement: null,
            newTheme: webase.utils.theme.newTheme()
        }
    },
    mounted() {
        this.modalElement = document.getElementById('newThemeModal')
        this.currentModal = new bootstrap.Modal(this.modalElement)
        this.modalElement.addEventListener('hidden.bs.modal', this.onModalHidden)
        this.currentModal.show()
    },
    beforeUnmount() {
        this.modalElement.removeEventListener('hidden.bs.modal', this.onModalHidden)
    },
    methods: {
        onModalHidden() {
            this.$emit('noEvent')
        },
        noHandler(e) {
            this.currentModal.hide()
        },
        yesHandler(e) {
            // call the parent's "yesEvent"
            if (this.yesEvent) {
                this.yesEvent(this.newTheme)
            }

            // hide the modal
            this.noHandler()
        },
    }
}
</script>
